module.exports = __webpack_public_path__ + "img/kefu-icon.80f88688.png";